import { useMaintenanceMode } from 'hooks/queries/useMaintenanceMode'
import { Redirect } from 'react-router-dom'
import Styles from './MaintenanceMode.module.scss'
import { ReactComponent as Logo } from './logo.svg'

export const MaintenanceMode = () => {
  const { data: inMaintenanceMode, isLoading } = useMaintenanceMode()

  if (isLoading) {
    return null
  }

  if (!inMaintenanceMode) {
    return <Redirect to="/" />
  }

  return (
    <div className={Styles.maintenance}>
      <Logo className={Styles.logo} />
      <h1 className={Styles.title}>We're temporarily offline.</h1>
      <p>
        We're in the middle of performing some scheduled maintenance. We should be back online shortly.
        <br />
        Check out <a href="https://status.almanac.io">status.almanac.io</a> for real-time updates.
      </p>
    </div>
  )
}

export default MaintenanceMode
